// extracted by mini-css-extract-plugin
export default {"body":"ZohoDisconnectModal_body__WZGMa","bodyText":"ZohoDisconnectModal_bodyText__jqSXw"};